import React from 'react'

// Types
import { Dispatch } from 'redux'
import { AppState } from '../../types'
import { LocalizationState, LocalizationProps } from './types'

import { connect } from 'react-redux'
import { setLanguage, fetchLanguage } from './actions'

class Localization extends React.Component<LocalizationProps> {

  async componentWillMount() {
    await this.props.fetchLanguage()
  }

  render() {
    return this.props.children || null
  }

}

const mapStateToProps = (state: AppState): { localization: LocalizationState } => ({
  localization: state.localization
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setLanguage: (language: string) => dispatch(setLanguage(language)),
  fetchLanguage: () => dispatch(fetchLanguage())
})

export default connect(mapStateToProps, mapDispatchToProps)(Localization)
